export default function senhaIncorretaVisual(ref) {
    let div = ref.current;
    div.classList.add("tremerDiv");
    setTimeout(function () { div.classList.remove("tremerDiv") }, 600);
};
